import React from 'react'
import classes from './MyButton.module.css'

export default function MyButton({ body, icon, className, ...props }) {
  return (
    <button className={`${classes.button28} ${className || ""}`} {...props}>
      {icon && <span className={classes.icon}>{icon}</span>}
      {body}
    </button>
  )
}
